import { PercentageValue } from "../../../percentage_value";

type MatchCellProps = {
  value: string | undefined;
};

export const MatchCell = ({ value }: MatchCellProps) => <PercentageValue value={value} isNormalized />;
